import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { months } from "../../Utils/Utils";
import {
  COURBE,
  LISTE_COMMUNE_SANS_PAGINATION,
  RECUPERER_DATA_COUNTER,
  RECUPERE_GRAPHE_CHIFFRE_AFFAIRE,
  RECUPERE_GRAPHE_INSTALLATION,
} from "../../Utils/constant";
import { DateFilter } from "../../components/Widget/DateFilter";
import { find, getStat, getStatCounter, store } from "../../services/service";
import { Performance } from "./Performance";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip);

export const Home = () => {
  const [loadingData, setloadingData] = useState(true);
  const [dataCounter, setDataCounter] = useState(null);
  const [dataRDV, setDataRDV] = useState(null);
  // Brins
  const [communeId, setCommuneId] = useState("");
  const [pboId, setPboId] = useState("");
  const [brins, setBrins] = useState([]);
  const [loadingBrins, setLoadingBrins] = useState(false);
  const [communes, setCommunes] = useState([]);
  const [pbos, setPbos] = useState([]);

  const fetchCommunes = async () => {
    await find(`${LISTE_COMMUNE_SANS_PAGINATION}?prestataireId=`)
      .then((res) => {
        setCommunes(res.data || []);
      })
      .catch((err) => {
        setCommunes([]);
      });
  };
  const fetchPbos = async (communeId) => {
    await find(`/commerciale/pbo/rechercher-liste-pbo-par-commune/${communeId}`)
      .then((res) => {
        setPbos(res.data?.donnee || []);
      })
      .catch((err) => {
        setPbos([]);
      });
  };
  useEffect(() => {
    fetchCommunes();
  }, []);

  // Récupérer les brins filtrés
  const fetchBrins = async () => {
    setLoadingBrins(true);
    await find(
      `/commerciale/brin/rechercher-brins?pboId=${pboId}&communeId=${communeId}&status=&page=0&size=20`,
    )
      .then((res) => {
        setBrins(res.data?.data || []);
        setLoadingBrins(false);
      })
      .catch((err) => {
        setBrins([]);
        setLoadingBrins(false);
      });
  };

  useEffect(() => {
    if (communeId || pboId) {
      fetchBrins();
    }
  }, [communeId, pboId]);
  const [grapheInstallation, setGrapheInstallation] = useState({
    data: {
      labels: months.map((item) => item.name),
      datasets: [
        {
          label: "Nombre installation",
          data: [59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55],
          backgroundColor: "#ccccc",
          borderColor: "white",
          borderRadius: 3,
          borderSkipped: false,
        },
      ],
    },
    options: {
      responsive: true,
      plugins: {
        title: {
          display: true,
          text: "",
        },
      },
      scales: {
        y: {
          display: false,
        },
        xAxes: [
          {
            maxBarThickness: 100,
          },
        ],
        x: {
          grid: {
            display: false,
          },
        },
      },
    },
  });
  const [grapheChiffreAffaire, setGrapheChiffreAffaire] = useState({
    data: {
      labels: months.map((item) => item.name),
      datasets: [
        {
          label: "Chiffre d'affaire",
          data: [159, 800, 281, 856, 515, 140, 265, 159, 780, 181, 256, 455],
          backgroundColor: "#fbbf24",
          borderColor: "white",
          borderRadius: 3,
          borderSkipped: false,
        },
      ],
    },
    options: {
      responsive: true,
      plugins: {
        title: {
          display: true,
          text: "",
        },
      },
      scales: {
        y: {
          display: false,
        },
        xAxes: [
          {
            maxBarThickness: 100,
          },
        ],
        x: {
          grid: {
            display: false,
          },
        },
      },
    },
  });

  const recupereCounterData = (filterParam) => {
    setloadingData(true);
    getStatCounter(RECUPERER_DATA_COUNTER, filterParam)
      .then((res) => {
        setloadingData(false);
        setDataCounter(res.data);
        setDataRDV(res.data);
      })
      .catch((err) => {
        console.log(err);
        setloadingData(false);
      });
  };

  const recupereChiffreAffaire = (filterParam) => {
    getStat(RECUPERE_GRAPHE_CHIFFRE_AFFAIRE, "application/json", filterParam)
      .then((res) => {
        setGrapheChiffreAffaire((prev) => ({
          ...prev,
          data: {
            labels: res.data.labels,
            datasets: [
              {
                label: "Chiffre d'affaire",
                data: res.data.data,
                backgroundColor: "#fbbf24",
                borderColor: "white",
                borderRadius: 3,
                borderSkipped: false,
              },
            ],
          },
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const recupereDataInstallation = (filterParam) => {
    getStat(RECUPERE_GRAPHE_INSTALLATION, "application/json", filterParam)
      .then((res) => {
        setGrapheInstallation((prev) => ({
          ...prev,
          data: {
            labels: res.data.labels,
            datasets: [
              {
                label: "Nombre installation",
                data: res.data.data,
                backgroundColor: "#ccccc",
                borderColor: "white",
                borderRadius: 3,
                borderSkipped: false,
              },
            ],
          },
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const filterChiffreAffaireByParam = (filter) => {
    const filterParam = {
      periode: filter.periode,
      mois: filter.mois,
      annee: filter.annee,
      dateDebut: filter.debut,
      dateFin: filter.fin,
      status: filter.status,
    };
    recupereChiffreAffaire(filterParam);
  };

  const filterInstallationByParam = (filter) => {
    const filterParam = {
      periode: filter.periode,
      mois: filter.mois,
      annee: filter.annee,
      dateDebut: filter.debut,
      dateFin: filter.fin,
      status: filter.status,
    };
    recupereDataInstallation(filterParam);
  };

  useEffect(() => {
    const date = new Date();
    const filterParam = {
      periode: "MOIS",
      mois: date.getMonth() + 1,
      annee: date.getFullYear(),
      dateDebut: "",
      dateFin: "",
      status: "",
    };

    store(COURBE, "application/json", filterParam);

    recupereCounterData(filterParam);
    recupereChiffreAffaire(filterParam);
    recupereDataInstallation(filterParam);
  }, []);

  return (
    <div className="">
      <div className="mb-8">
        <div className="lg:flex gap-x-2 ">
          <h1 className="font-mtn text-3xl font-extrabold text-black">
            Performance Ftth
          </h1>
        </div>

        <Performance />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-2 gap-4">
          <div>
            <h1 className="text-md font-semibold">Installations de la FTTH</h1>
            <div className="mt-2 bg-white border rounded-lg shadow-sm">
              <div className=" bg-muted/50 gap-4 p-4">
                <DateFilter filtrerInstallation={filterInstallationByParam} />
              </div>
              <Bar
                className="mt-4 p-4"
                height={180}
                options={grapheInstallation.options}
                data={grapheInstallation.data}
              />
            </div>
          </div>

          <div>
            <h1 className="text-md font-semibold">
              Chiffre d'affaire de la FTTH
            </h1>
            <div className="mt-2 bg-white border rounded-lg shadow-sm">
              <div className="bg-muted/50 gap-4 p-4">
                <DateFilter
                  filtrerChiffreAffaire={filterChiffreAffaireByParam}
                />
              </div>
              <Bar
                className="mt-4 p-4"
                height={180}
                options={grapheChiffreAffaire.options}
                data={grapheChiffreAffaire.data}
              />
            </div>
          </div>
        </div>
        {/* Section Brins disponibles */}
        <div className="shadow border p-8 rounded-lg mt-8 space-y-6">
          {/* Header avec titre et filtres */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex items-center gap-4">
              <h2 className="text-2xl font-semibold text-gray-900 font-mtn">
                Brins disponibles
              </h2>
              <span className="text-sm text-gray-500">
                {brins.length} {brins.length > 1 ? "résultats" : "résultat"}
              </span>
            </div>

            <div className="flex gap-2">
              <select
                className="px-4 py-2 text-sm border border-gray-200 rounded-lg bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all"
                onChange={(e) => fetchPbos(e.target.value)}
              >
                <option value="">Commune</option>
                {communes.map((commune) => (
                  <option key={commune.id} value={commune.id}>
                    {commune.designation}
                  </option>
                ))}
              </select>

              <select
                className="px-4 py-2 text-sm border border-gray-200 rounded-lg bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all"
                value={pboId}
                onChange={(e) => setPboId(e.target.value)}
              >
                <option value="">PBO</option>
                {pbos.map((pbo) => (
                  <option key={pbo.id} value={pbo.id}>
                    {pbo.nom}
                  </option>
                ))}
              </select>

              <button
                className="px-4 py-2 text-sm bg-primary text-black rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all font-medium"
                onClick={fetchBrins}
                disabled={loadingBrins}
              >
                {loadingBrins ? "Recherche..." : "Rechercher"}
              </button>
            </div>
          </div>

          {/* Liste des brins */}
          {loadingBrins ? (
            <div className="text-center py-16 text-gray-400">Chargement...</div>
          ) : brins.length === 0 ? (
            <div className="text-center py-16 text-gray-400">
              Aucun brin disponible
            </div>
          ) : (
            <div className="space-y-3">
              {brins.map((brin) => (
                <div
                  key={brin.id}
                  className="bg-white rounded-2xl p-5 hover:shadow-md transition-shadow border border-gray-100 group"
                >
                  <div className="flex items-center gap-4">
                    {/* Icône */}
                    <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                      <svg
                        className="w-6 h-6 text-gray-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13 10V3L4 14h7v7l9-11h-7z"
                        />
                      </svg>
                    </div>

                    {/* Contenu principal */}
                    <div className="flex-1 min-w-0">
                      <h3 className="font-medium text-gray-900 truncate">
                        {brin.designation}
                      </h3>
                      <div className="flex items-center gap-3 mt-1 text-sm text-gray-500">
                        <span>{brin.pboDesignation}</span>
                        <span className="text-gray-300">•</span>
                        <span>{brin.communeDesignation}</span>
                      </div>
                    </div>

                    {/* Status badge */}
                    <div className="flex items-center gap-4">
                      <span
                        className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium ${
                          brin.status === "LIBRE"
                            ? "bg-green-50 text-green-600"
                            : brin.status === "En cours"
                              ? "bg-orange-50 text-orange-600"
                              : "bg-gray-50 text-gray-600"
                        }`}
                      >
                        <span
                          className={`w-2 h-2 rounded-full ${
                            brin.status === "LIBRE"
                              ? "bg-green-500"
                              : brin.status === "En cours"
                                ? "bg-orange-500"
                                : "bg-gray-400"
                          }`}
                        ></span>
                        {brin.status}
                      </span>

                      {/* Menu points */}
                      <button className="opacity-0 group-hover:opacity-100 transition-opacity p-2 hover:bg-gray-100 rounded-lg">
                        <svg
                          className="w-5 h-5 text-gray-400"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        {/* <GrapheGlobale /> */}
      </div>
    </div>
  );
};
